import { ReactElement } from 'react';
import ForgetPasswordPage from './views';

const ForgetPasswordRoute = (): ReactElement => (
  <ForgetPasswordPage />
);

export default ForgetPasswordRoute;
